import { fetcher } from './api';

export interface ProfilePhotoResponse {
  photo: string;
  user_email: string;
  user_name: string;
}

export const profileService = {
  getPhoto: (): Promise<ProfilePhotoResponse> =>
    fetcher<ProfilePhotoResponse>('/api/v1/profile/photo/me'),
};
